import { __assign } from "tslib";
// DS: i5.2
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import IconWrap from '../../IconWrap';
var Comment = function (props) {
    var isBrowseV2 = useFlag('browsev2_thumbs');
    return (React.createElement(IconWrap, __assign({}, props),
        isBrowseV2 && (React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 2a1 1 0 0 0-1-1H3.914a1 1 0 0 0-.707.293L1.293 3.207A1 1 0 0 0 1 3.914V11a1 1 0 0 0 1 1h3v2a1 1 0 0 0 1 1h.465a1 1 0 0 0 .832-.445L9 12h3.086a1 1 0 0 0 .707-.293l1.914-1.914A1 1 0 0 0 15 9.086V2Z" }))),
        !isBrowseV2 && (React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("path", { fillRule: "evenodd", d: "M14 1H3.914a1 1 0 00-.707.293L1.293 3.207A1 1 0 001 3.914V11a1 1 0 001 1h3v2a1 1 0 001 1h.465a1 1 0 00.832-.445L9 12h3.086a1 1 0 00.707-.293l1.914-1.914A1 1 0 0015 9.086V2a1 1 0 00-1-1z" })))));
};
Comment.displayName = 'Comment';
export default Comment;
//# sourceMappingURL=Comment.js.map